export default {
    common: {
        appName: 'Swift Invoice',
        cancel: 'キャンセル',
        email: 'メールアドレス',
        password: 'パスワード',
        or: 'または',
        change: '変更',
        delete: '削除',
        save: '保存',
        edit: '編集',
        add: '追加',
        close: '閉じる',
        date: '日付',
        total: '合計',
        status: 'ステータス',
        amount: '金額',
        quantity: '数量',
        rate: '単価',
        tax: '税金',
        discount: '割引',
        note: 'メモ',
        notes: 'メモ',
        description: '説明',
        client: '顧客',
        item: 'アイテム',
        items: 'アイテム',
        type: '種類',
        category: 'カテゴリー',
        phone: '電話番号',
        name: '名前',
        subject: '件名',
        saveAndClose: '保存して閉じる',
        saveAndSendEmail: '保存してメールを送信',
        sendEmail: 'メールを送信',
        send: '送信',
        print: '印刷',
        moreActions: 'その他の操作',
        preparingPdf: 'PDFを準備しています...',
        pdfPreparationFailed: 'PDFを準備できませんでした',
        warning: '警告',
        ok: 'OK',
        uploadSuccess: 'アップロード成功',
        saveSuccess: '保存成功',
        deleteSuccess: '削除成功',
        deleteFailed: '削除失敗',
        saveFailed: '保存失敗',
        loadFailed: '読み込み失敗',
        systemError: 'システムエラー',
        sendSuccess: '送信成功',
        updateSuccess: '更新成功',
        unsavedChangesMsg: '未保存の変更があります。保存しますか、破棄しますか？',
        saveChangesTitle: '変更を保存しますか？',
        confirmSave: '保存',
        discard: '破棄',
        validEmail: '有効なメールアドレスを入力してください',
        deleteFailedMsg: '削除失敗',
        shipping: '配送',
        attachment: '添付ファイル',
        days: '日',
        excl: '(税抜)',
        incl: '(税込)',
        of: '/'
    },
    login: {
        heroPrefix: 'スマートな',
        heroInvoicing: '請求書管理',
        heroMiddle: '、',
        heroSimplified: 'シンプル化',
        heroSuffix: 'をお届けします。',
        subtitle1: '請求書を簡単に作成・送信・管理できます。',
        subtitle2: 'Swift Invoice でより早く入金を受け取りましょう。',
        feature1Title: 'プロフェッショナルな請求書',
        feature1Text: '数分で美しい請求書を作成',
        feature2Title: 'リアルタイム追跡',
        feature2Text: '支払いと請求書ステータスを追跡',
        feature3Title: '安全・安心',
        feature3Text: 'エンタープライズレベルのセキュリティでデータを保護',
        welcomeBack: 'おかえりなさい',
        signInToContinue: '続行するにはアカウントにサインインしてください',
        enterEmail: 'メールアドレスを入力',
        enterPassword: 'パスワードを入力',
        rememberMe: 'ログイン情報を保存',
        forgotPassword: 'パスワードをお忘れですか？',
        signIn: 'サインイン',
        signingIn: 'サインイン中…',
        continueWithGoogle: 'Google で続行',
        continueWithApple: 'Apple で続行',
        createAccount: 'アカウント作成',
        startUsing: 'Swift Invoice を始める',
        companyName: '会社名',
        enterCompanyName: '会社名を入力してください',
        alreadyHaveAccount: 'すでにアカウントをお持ちですか？サインイン',
        footerRights: '© 2026 Swift Invoice. All rights reserved.',
        termsOfService: '利用規約',
        contactUs: 'お問い合わせ: goodinvoicego@gmail.com',
        betaDialogBody: 'チームがウェブ版の第1版を完成させました <br> このバージョンは iPhone ユーザーのみ利用可能です <br> ウェブ機能はできるだけ早く改善し、すべてのユーザーに公開予定です <br>',
        ieDialogBody: '申し訳ありません、IE ブラウザには互換性の問題があるため、現在 IE ブラウザには対応していません。ご利用の際はダウンロードしてください',
        resetPasswordTitle: 'パスワードリセット',
        sendResetEmail: 'リセットメールを送信',
        resetEmailSent: 'パスワードリセットメールを送信しました。受信箱をご確認ください。',
        bindingTitle: '既存アカウントを連携',
        bindingHintPrefix: 'このメールアドレス ',
        bindingHintSuffix: ' はすでに別のアカウントで使用されています。Google サインインを連携するには、そのアカウントのパスワードを入力してください。',
        enterAccountPassword: 'アカウントのパスワードを入力',
        linkAccount: 'アカウントを連携',
        validEmail: '有効なメールアドレスを入力してください',
        validPassword: 'パスワードは6文字以上でなければなりません',
        validCompanyName: '会社名を入力してください'
    },
    account: {
        title: 'アカウント',
        profile: 'プロフィール',
        swiftAccount: 'Swift Invoice アカウント',
        connectSocial: 'ソーシャルアカウントを連携',
        companyLogo: '会社ロゴ',
        addLogo: 'ロゴを追加',
        uploading: 'アップロード中...',
        currentPlan: '現在のプラン: Swift {plan}',
        planActiveUntil: 'プラン有効期限: {date}',
        sharedWithMobile: 'モバイルと共有',
        subscriptionExpired: 'サブスクリプションの有効期限が切れています',
        planNote: 'サブスクリプションのステータスが更新されていない場合は、再度ログインしてください。',
        upgradeToPro: 'Swift Pro にアップグレード',
        viewPlans: 'サブスクリプションプランを表示',
        connecting: '連携中…',
        connectGoogle: 'Google を連携',
        googleConnected: 'Google 連携済み',
        googleConnectedWithEmail: 'Google 連携済み ({email})',
        connectApple: 'Apple を連携',
        appleConnected: 'Apple 連携済み',
        appleConnectedWithEmail: 'Apple 連携済み ({email})',
        logoUuidMissing: '会社ロゴの UUID が見つかりません',
        googleConnectedToast: 'Google アカウントが連携されました。',
        appleConnectedToast: 'Apple アカウントが連携されました。'
    },
    menu: {
        invoices: '請求書',
        estimates: '見積書',
        purchaseOrders: '発注書',
        items: 'アイテム',
        clients: '顧客',
        expenses: '経費',
        reports: 'レポート',
        settings: '設定',
        companyInfo: '会社情報',
        taxes: '税金',
        default: 'デフォルト',
        customizeInvoice: '請求書をカスタマイズ',
        sendFeedback: 'フィードバックを送信',
        newReply: '新しい返信 1件',
        signOut: 'サインアウト',
        signOutConfirm: 'サインアウトしてもよろしいですか？',
        addBusiness: '事業を追加',
        newBusinessTitle: '新しい事業',
        businessName: '事業名',
        businessNamePlaceholder: '事業名を入力してください',
        createBusiness: '作成',
        businessNameRequired: '事業名を入力してください',
        createBusinessSuccess: '事業を作成しました'
    },
    network: {
        loginExpired: 'ログインの有効期限が切れました。再度ログインしてください',
        requestTimeout: 'リクエストがタイムアウトしました。ネットワークを確認してください'
    },
    language: {
        label: '言語',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        searchPlaceholder: '請求書を検索',
        addInvoice: '請求書を追加',
        overdueInvoices: '期限超過の請求書',
        paidInvoices: '支払済みの請求書',
        unpaidInvoices: '未払いの請求書',
        unsentInvoices: '未送信の請求書',
        columnNumber: '番号',
        columnClient: '顧客',
        columnStatus: 'ステータス',
        statusFullyPaid: '全額支払済み',
        statusPartial: '一部支払い',
        statusOverdue: '期限超過',
        statusUnsent: '未送信',
        statusSent: '送信済み',
        statusOpened: '開封済み',
        actionRecordPayment: '支払いを記録',
        actionMarkAsSent: '送信済みにする',
        actionCopy: 'コピー',
        actionDelete: '削除',
        copyDialogTitle: '請求書をコピー',
        copyTargetType: 'コピー先',
        copyOptions: 'コピーオプション',
        copyClient: 'クライアントをコピー',
        copyItems: 'アイテムをコピー',
        copyAttachments: '添付ファイルをコピー',
        confirmDelete: 'この請求書が削除されます。続行しますか？',
        copySuccess: '請求書をコピーしました',
        copyFailed: 'コピーに失敗しました',
        deleteSuccess: '請求書を削除しました',
        deleteFailed: '削除に失敗しました',
        recordPaymentDialogTitle: '支払いを記録',
        markAsFullyPaid: '全額支払済みにする',
        formAmount: '金額',
        formDate: '日付',
        formPaymentMethod: '支払い方法',
        formNote: 'メモ',
        allYears: 'すべての年',
        errorMorePaymentThanBalanceDue: '未払残高より多くの支払いが入力されています',
        errorAmountMustBeGreaterThanZero: '金額は0より大きくしてください',
        dueDateToday: '今日',
        dueDateDaysAgo: '{days}日前',
        dueDateInDays: '{days}日後'
    },
    estimate: {
        pageTitlePurchaseOrders: '発注書',
        pageTitleEstimates: '見積書',
        searchPlaceholderPurchaseOrders: '発注書を検索',
        searchPlaceholderEstimates: '見積書を検索',
        addPurchaseOrder: '発注書を追加',
        addEstimate: '見積書を追加',
        columnNumber: '番号',
        columnClient: '顧客',
        columnDate: '日付',
        columnEmail: 'メールアドレス',
        columnStatus: 'ステータス',
        columnTotal: '合計',
        statusUnsent: '未送信',
        statusSent: '送信済み',
        actionMarkAsSent: '送信済みにする',
        actionCopy: 'コピー',
        actionDelete: '削除',
        actionConvertToInvoice: '請求書に変換',
        copyDialogTitle: '{document}をコピー',
        copyTargetType: 'コピー先',
        copyOptions: 'コピーオプション',
        copyClient: 'クライアントをコピー',
        copyItems: 'アイテムをコピー',
        copyAttachments: '添付ファイルをコピー',
        confirmDelete: 'この{document}が削除されます。続行しますか？',
        convertConfirm: 'この{document}を請求書に変換しますか？日付は今日に設定されます。',
        copySuccess: '{document}をコピーしました',
        copyFailed: 'コピーに失敗しました',
        convertSuccess: '{document}を請求書に変換しました',
        convertFailed: '変換に失敗しました',
        deleteSuccess: '{document}を削除しました',
        deleteFailed: '削除に失敗しました',
        dueDateToday: '今日',
        dueDateDaysAgo: '{days}日前',
        dueDateInDays: '{days}日後'
    },
    item: {
        pageTitle: 'アイテム',
        searchPlaceholder: 'アイテムを検索',
        addItem: 'アイテムを追加',
        columnInventoryCountUnit: '在庫数/単位'
    },
    client: {
        pageTitle: '顧客',
        searchPlaceholder: '顧客を検索',
        addClient: '顧客を追加',
        columnClientName: '顧客名',
        columnEmail: 'メールアドレス',
        columnPhone: '電話番号',
        columnBalanceDue: '未払残高',
        noNameFallback: '名前なし'
    },
    expense: {
        pageTitle: '経費',
        searchPlaceholder: '経費を検索',
        addExpense: '経費を追加',
        columnDescription: '説明',
        columnDate: '日付',
        columnTotal: '合計'
    },
    report: {
        headerTitle: 'レポート',
        tabDashboard: 'ダッシュボード',
        tabReportList: 'レポート一覧',
        export: 'エクスポート',
        annualSalesByClient: '顧客別年間売上',
        totalOutstandingBalance: '未払残高合計',
        invoicesCountSuffix: '件の請求書',
        byMonth: '月別',
        byQuarter: '四半期別',
        noSalesFound: '売上が見つかりません',
        filterReportTypes: 'レポート種別',
        filterTimePeriod: '期間',
        filterView: '表示',
        optionMonthly: '月次',
        optionQuarterly: '四半期',
        customerAgingTitle: '顧客エイジング',
        noDataForDateRange: 'この期間のデータはありません',
        typeSalesByDate: '日別売上',
        typeSalesByClient: '顧客別売上',
        typeSalesByItem: 'アイテム別売上',
        typeSalesJournal: '売上仕訳帳',
        typePaymentsByDate: '日別支払い',
        typePaymentsByClient: '顧客別支払い',
        typePaymentsByType: '種類別支払い',
        typePaymentsJournal: '支払い仕訳帳',
        typeExpenseByCategory: 'カテゴリー別経費',
        typeExpenseJournal: '経費仕訳帳',
        typeCustomerAging: '顧客エイジング',
        allYears: 'すべての年',
        allTime: '全期間',
        allSales: '全売上',
        taxYearSales: '会計年度 {year} 売上',
        firstColumnMonth: '月',
        firstColumnQuarter: '四半期',
        columnSubTotal: '小計',
        columnTax: '税金',
        columnDiscount: '割引',
        columnTotal: '合計',
        columnAmountPaid: '支払済額',
        columnAmountOwed: '未払額',
        columnClient: '顧客',
        columnItem: 'アイテム',
        columnUnitType: '単位の種類',
        columnQuantity: '数量',
        columnRateAvg: '単価 (平均)',
        columnInvoiceDate: '請求日',
        columnInvoiceNo: '請求書番号',
        columnType: '種類',
        columnPaymentDate: '支払日',
        columnCategory: 'カテゴリー',
        columnExpenseDate: '経費日',
        columnMerchant: '加盟店',
        columnDescription: '説明',
        columnCurrentDue: '現在の未払額',
        column1To30DaysOverdue: '1〜30日期限超過',
        column31To60DaysOverdue: '31〜60日期限超過',
        column61To90DaysOverdue: '61〜90日期限超過',
        column91PlusDaysOverdue: '91日以上期限超過',
        monthNames: '1月, 2月, 3月, 4月, 5月, 6月, 7月, 8月, 9月, 10月, 11月, 12月',
        totalRowLabel: '合計'
    },
    invoiceCreate: {
        pageTitlePrefix: '追加',
        invoicePrefix: '請求書プレフィックス',
        tabCreate: '作成',
        tabPreview: 'プレビュー',
        tabSendEmail: 'メール送信',
        sectionClient: '顧客',
        addClient: '顧客を追加',
        dialogClientInfo: '顧客情報',
        basicInformation: '基本情報',
        labelName: '名前',
        labelEmail: 'メールアドレス',
        labelPhone: '電話番号',
        billingAddress: '請求先住所',
        labelLine1: '住所1',
        labelLine2: '住所2',
        labelLine3: '住所3',
        shippingAddress: '配送先住所',
        labelShippingName: '配送先名',
        labelNotes: 'メモ',
        placeholderCreateOrSelect: '作成または選択...',
        placeholderClientNotes: '顧客に関するメモを追加します。顧客には表示されません',
        sectionItems: 'アイテム',
        saveToYourItem: 'アイテムとして保存',
        stock: '在庫:',
        placeholderItemCode: 'アイテムコード',
        placeholderQuantity: '数量',
        placeholderRate: '単価',
        placeholderInputDescription: '説明を入力',
        placeholderInputComment: 'コメントを入力',
        placeholderAddRecipient: '受信者を追加',
        cc: 'Cc',
        bcc: 'Bcc',
        placeholderEmailSubject: 'メール件名',
        placeholderMessage: 'メッセージを入力...',
        labelTo: '宛先',
        labelSubject: '件名',
        sectionAttachments: '添付ファイル',
        sectionComment: 'コメント',
        addItem: 'アイテムを追加',
        addPhoto: '写真を追加',
        addPayment: '支払いを追加',
        goBack: '戻る',
        dialogShippingInfo: '配送情報',
        dialogRecordPayment: '支払いを記録',
        dialogJobDetails: 'ジョブ詳細',
        labelAmount: '金額',
        labelShipDate: '発送日',
        labelShipVia: '配送業者',
        labelTrackingNumber: '追跡番号',
        labelFob: 'FOB',
        columnDate: '日付',
        columnType: '種類',
        msgClientEmailError: '顧客のメールアドレスエラー',
        msgAmountGreaterThanZero: '金額は0より大きくしてください',
        msgMorePaymentThanBalance: '未払残高より多くの支払いが入力されています',
        mailSentSuccessfully: 'メールの送信に成功しました',
        cumulativeTaxNotice: 'ウェブ版では請求書の税金の累算には対応していません...',
        numberLogicNotice: '最近、番号のロジックを変更しました。番号が正しくない場合は、ここで編集してください。また、設定 > 請求書のカスタマイズ > 次の番号に移動し、希望する開始番号を設定できます。',
        confirmUnsavedChanges: '未保存の変更があります。保存しますか、破棄しますか？',
        pdf: 'PDF',
        taxDiscountWithholding: '税金、割引、源泉徴収',
        purchaseOrder: '発注書',
        placeholderPurchaseOrderPrefix: '発注書プレフィックス',
        placeholderEstimatePrefix: '見積書プレフィックス',
        labelStatus: 'ステータス',
        statusIssued: '発行済み',
        statusApproved: '承認済み',
        statusPending: '保留中',
        statusWithdrawn: '取り下げ',
        tax: '税金'
    },
    createEstimate: {
        pageTitlePrefix: '追加',
        cumulativeTaxNotice: 'ウェブ版では見積書の税金の累算には対応していません...'
    },
    updateInvoice: {
        pageTitlePrefix: '更新',
        deletePrefix: '削除',
        confirmDelete: 'この請求書が削除されます。続行しますか？',
        cumulativeTaxNotice: 'この請求書には累算税金が含まれています。ウェブ版は現在この機能に対応していません'
    },
    updateEstimate: {
        pageTitlePrefix: '更新',
        deletePrefix: '削除',
        confirmDelete: 'この{document}が削除されます。続行しますか？',
        cumulativeTaxNotice: 'この見積書には累算税金が含まれています。ウェブ版は現在この機能に対応していません'
    },
    createAccount: {
        title: 'アカウント作成',
        placeholderEmail: 'メールアドレス',
        placeholderPassword: 'パスワード',
        placeholderCompanyName: '会社名',
        createAccountButton: 'アカウント作成',
        alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
        signIn: 'サインイン',
        validEmail: '有効なメールアドレスを入力してください',
        validPassword: 'パスワードは6文字以上でなければなりません',
        validCompanyName: '会社名を入力してください'
    },
    clientCreate: {
        pageTitle: '顧客を追加',
        basicInformation: '基本情報',
        labelName: '名前',
        placeholderName: '名前を入力...',
        labelEmail: 'メールアドレス',
        placeholderEmail: 'メールアドレスを入力...',
        labelPhone: '電話番号',
        placeholderPhone: '電話番号を入力...',
        billingAddress: '請求先住所',
        labelLine1: '住所1',
        labelLine2: '住所2',
        labelLine3: '住所3',
        shippingAddress: '配送先住所',
        sameAsBilling: '請求先住所と同じ',
        labelShippingName: '配送先名',
        labelShippingLine1: '住所1',
        labelShippingLine2: '住所2',
        labelShippingLine3: '住所3',
        labelNotes: 'メモ',
        placeholderNotes: '顧客に関するメモを追加します。顧客には表示されません',
        validEmail: '有効なメールアドレスを入力してください'
    },
    clientUpdate: {
        pageTitle: '顧客を更新',
        confirmDelete: 'この顧客が削除されます。続行しますか？'
    },
    itemCreate: {
        pageTitle: 'アイテムを追加',
        itemTitle: 'アイテム',
        labelCost: '原価',
        labelUnit: '単位',
        placeholderUnit: '単位',
        defaultTaxes: 'デフォルト税金',
        taxOff: 'オフ',
        inventoryTitle: '在庫',
        currentInventory: '現在の在庫',
        adjustInventory: '在庫を調整',
        placeholderQuantity: '数量',
        placeholderDateAndTime: '日時',
        placeholderNote: 'メモ',
        addButton: '追加',
        columnDate: '日付',
        columnQuantity: '数量',
        columnNote: 'メモ',
        withholdingTitle: '源泉徴収',
        msgInventoryCannotDisable: '在庫機能は一度有効にすると無効にできません',
        msgDescriptionRequired: '商品説明は必須です',
        msgQuantityRequired: '数量は必須です',
        msgDateRequired: '日時は必須です'
    },
    itemUpdate: {
        pageTitle: 'アイテムを編集',
        columnInvoice: '請求書',
        confirmDelete: 'このアイテムが削除されます。続行しますか？'
    },
    createStatement: {
        pageTitle: '明細書',
        tabPreview: 'プレビュー',
        tabSendEmail: 'メール送信'
    },
    setting: {
        taxInfo: '税金情報',
        taxes: '税金',
        taxYearStarts: '会計年度の開始',
        taxYearStartSubtitle: '会計年度の最初の日を設定',
        rateLabel: '税率(%)',
        abbreviation: '略称',
        addTax: '税金を追加',
        month: '月',
        day: '日',
        monthPlaceholder: '月',
        dayPlaceholder: '日',
        saveTaxYearStart: '保存',
        deleteDialogTitle: '削除',
        confirmDeleteTax: 'この税金を削除してもよろしいですか？',
        deleteConfirm: '削除',
        taxInfoDialogTitle: '税金情報',
        taxName: '税名',
        standardRate: '標準税率 (%)',
        additionalRate: '追加税率',
        deleteRateX: 'X',
        addRate: '税率を追加',
        taxType: '税の種類',
        exclusive: '税抜',
        inclusive: '税込',
        close: '閉じる',
        saveTax: '税金を保存',
        cantOpenDetailMessage: 'この税金には累算税金が含まれています。ウェブ版は現在この機能に対応していません',
        closeButton: '閉じる',
        rateIsRequired: '税率は必須です',
        rateIsRequiredMsg: '税率は必須です',
        monthAndDayRequired: '月と日は必須です',
        moreRate: '件の追加税率',
        moreRates: '件の追加税率'
    },
    companyInfo: {
        title: '会社情報',
        details: '詳細',
        businessName: '事業名',
        businessNamePlaceholder: '事業名',
        name: '名前',
        phone: '電話番号',
        email: 'メールアドレス',
        businessNumber: '事業者番号',
        taxNo: '税番号 N°',
        deleteField: '削除',
        addNewField: '新しい項目を追加',
        address: '住所',
        line1: '住所1',
        line2: '住所2',
        line3: '住所3',
        currency: '通貨',
        currencyLabel: '通貨',
        symbol: '記号',
        placement: '配置',
        before: '前',
        after: '後',
        thousandSymbol: '桁区切り記号',
        decimalSymbol: '小数点記号',
        decimalPlaces: '小数点以下の桁数',
        example: '例',
        terms: '支払条件',
        termsLabel: '支払条件',
        termSameDay: '当日',
        term7Days: '7日',
        term14Days: '14日',
        term21Days: '21日',
        term30Days: '30日',
        term45Days: '45日',
        term60Days: '60日',
        term90Days: '90日',
        term180Days: '180日',
        term365Days: '365日',
        paymentInfo: '支払い情報',
        displayOnInvoices: '請求書に表示',
        titlePlaceholder: 'タイトル',
        jobDetails: 'ジョブ詳細',
        deleteJobDetail: '削除',
        addNewJobField: '新しい項目を追加'
    },
    default: {
        title: 'デフォルト',
        emailMessage: 'メールメッセージ',
        enterDescription: '説明を入力',
        emailCc: 'メール Cc',
        emailBcc: 'メール Bcc',
        emailTip: '上記のアドレスにも同時にメールを送信します。',
        defaultComments: 'デフォルトコメント',
        invoice: '請求書',
        estimate: '見積書',
        purchaseOrder: '発注書',
        creditMemo: 'クレジットメモ',
        emailValidError: 'メールアドレスが有効です'
    },
    invoiceDesign: {
        template: 'テンプレート',
        color: 'カラー',
        labels: 'ラベル',
        labelInvoice: '請求書',
        labelEstimate: '見積書',
        labelPurchaseOrder: '発注書',
        labelCreditMemo: 'クレジットメモ',
        labelReceipt: '領収書',
        labelTermsFormat: '支払条件の書式',
        labelBillTo: '請求先',
        labelFor: '宛先',
        labelDate: '日付',
        labelInvoiceNo: '請求書番号',
        labelEstimateNo: '見積書番号',
        labelPoNo: '発注書番号',
        labelCreditMemoNo: 'クレジットメモ番号',
        labelDueDate: '支払期限',
        labelTerms: '支払条件',
        labelAmount: '金額',
        labelCode: 'コード',
        labelDescription: '説明',
        labelQuantity: '数量',
        labelRate: '単価',
        labelTax: '税金',
        labelSubtotal: '小計',
        labelBalanceDue: '未払残高',
        labelDiscount: '割引',
        labelNonTaxableItem: '非課税アイテム',
        labelPaid: '支払済み',
        labelShipping: '配送',
        labelTotal: '合計',
        labelIncludes: '内訳',
        labelTotalAmountPaid: '支払済総額',
        labelShipDate: '発送日',
        labelShipTo: '配送先',
        labelShipVia: '配送業者',
        labelTrackingNo: '追跡番号',
        labelFob: 'F.O.B',
        prefix: 'プレフィックス',
        prefixInvoice: '請求書',
        prefixEstimate: '見積書',
        prefixPurchaseOrder: '発注書',
        prefixCreditMemo: 'クレジットメモ',
        nextNumber: '次の番号',
        numberingBeginsAt: '番号の開始',
        nextNumberInvoice: '請求書',
        nextNumberEstimate: '見積書',
        nextNumberPurchaseOrder: '発注書',
        nextNumberCreditMemo: 'クレジットメモ',
        options: 'オプション',
        optionTerms: '支払条件',
        optionDueDate: '支払期限',
        optionShippingAddress: '配送先住所',
        optionProductCode: '商品コード',
        optionQuantityAndRate: '数量と単価',
        optionTax: '税金',
        optionAmount: '金額',
        optionNonTaxableItemStar: '非課税アイテムの印',
        optionTaxBreakdown: '税金内訳',
        optionPaymentHistory: '支払い履歴',
        optionStamp: 'スタンプ',
        optionPageNumber: 'ページ番号',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: "お取引ありがとうございます！私たちのサービスにご満足いただけたでしょうか。15日以内にお支払いください。ご質問やご意見はこちらまで：(111)111-1234、または example@owner.com までメールにてお問い合わせください。どんなご質問にも喜んでお答えいたします。",
        previewSubtotal: '小計',
        previewVat: 'VAT 17.00%',
        previewPayment1: '10月1日の支払い 2019',
        previewPayment2: '10月2日の支払い 2019'
    },
    feedback: {
        title: 'フィードバックを送信',
        invalidEmailNoticePrefix: 'アカウントのメールアドレスが無効なため、ご連絡できませんでした。有効なメールアドレスからフィードバックをお送りください:',
        invalidEmailNoticeSuffix: '可能であれば、問題のスクリーンショットを添付してください。調査と解決に役立ちます。',
        replyTip: '送信後、返信はメールにてご確認ください。',
        content: '内容',
        enterDescription: '説明を入力'
    },
    createExpense: {
        title: '経費を追加',
        description: '説明',
        expenseDescriptionPlaceholder: '経費の説明',
        total: '合計',
        tax: '税金',
        tip: 'チップ',
        expenseDate: '経費日',
        merchant: '加盟店',
        merchantPlaceholder: '加盟店名を入力',
        categoryPlaceholder: 'カテゴリーを選択',
        addNewCategory: '新しいカテゴリーを追加',
        deletePhoto: '削除',
        addPhoto: '写真を追加',
        deleteCategory: '削除',
        addCategory: 'カテゴリーを追加'
    },
    updateExpense: {
        title: '経費を更新',
        deleteExpense: '経費を削除',
        confirmDeleteMsg: 'この経費が削除されます。続行しますか？'
    },
    notFound: {
        oops: 'おっと！',
        notFoundMsg: 'お探しのページが見つかりません。',
        takeMeHome: 'ホームに戻る'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: '無料配送',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'コンピューター',
        previewItem2: '電話',
        previewItem3: 'バースデーケーキ',
        previewTaxRate: '17%',
        nonTaxableNote: '* 非課税アイテムを示します',
        thanksMessage: "お取引ありがとうございます！私たちのサービスにご満足いただけたでしょうか。15日以内にお支払いください。ご質問やご意見はこちらまで：(111)111-1234、または example@owner.com までメールにてお問い合わせください。どんなご質問にも喜んでお答えいたします。",
        subtotal: '小計',
        vat: 'VAT 17.00%',
        payment1: '10月1日の支払い 2019',
        payment2: '10月2日の支払い 2019',
        balanceDue: '未払残高'
    }
};
